import { instance } from "../apiclient";
import { CreateOrderObject, CreateGiftOrderObject } from "./Utilities";
import store from "../../store/index";
import { ReplaceAll } from "../helpers/stringHelper";
import uuid from "uuid/v1";
import { AppConfig } from "./../../../AppConfig.js";
// import { DateTime } from "luxon";

export class DefaultPaymentHandler {
  MakePayment(
    guid,
    card,
    user,
    resturant,
    orderInfo,
    guestUserId,
    paymentMethod,
    isGift = false,
    AppliedCouponList = [],
    loyalty = { RedeemPoints: 0, RewardPoints: 0 },
    twoStepPayment = false,
    stripeToken = null
  ) {
    var trackingOrderModel = this.MakePaymentBody(
      guid,
      card,
      user,
      resturant,
      orderInfo,
      guestUserId,
      paymentMethod,
      isGift,
      AppliedCouponList,
      loyalty,
      twoStepPayment,
      stripeToken
    );
    store.commit("addUserOrderHistory", trackingOrderModel.TrackingOrder);
    return instance.post("trackingorders/" + guid, trackingOrderModel);
  }

  MakePaymentBody(
    guid,
    card,
    user,
    resturant,
    orderInfo,
    guestUserId,
    paymentMethod,
    isGift = false,
    AppliedCouponList = [],
    loyalty = { RedeemPoints: 0, RewardPoints: 0 },
    twoStepPayment = false,
    stripeToken = null
  ) {
    var orderModel;
    if (isGift) {
      var surchareItem = {
        totalPrice: store.getters.giftTotalPrice,
        subTotalPrice: store.getters.giftCartValue,
        bankCardSurcharge: store.getters.getGiftcardSurchargeBankAmount,
        pOSSurchargeTax: store.getters.getGiftSurchargeHolidayValidTax,
        pOSSurchargeExcludingTax: 0,
        surchargeTransactions: store.getters.getSurchargeHolidayValid,
      };
      orderModel = CreateGiftOrderObject(
        store.state.giftShoppingCart,
        surchareItem,
        user,
        resturant,
        card,
        guid,
        orderInfo,
        AppliedCouponList
      );
    } else {
      let priceItem = {
        totalPrice: store.getters.getTotalPrice,
        subTotalPrice: store.getters.cartValue,
        totalTax: store.getters.totaltax,
        freeOrderItems: store.getters.getFreeOrderItems,
        discountTax: store.getters.discountTax,
        discountExcludingTax: store.getters.discountExcludingTax,
        bankCardSurcharge: store.getters.getSurchargeBankAmount,
        pOSSurchargeTax: store.getters.getSurchargeHolidayValidTax,
        pOSSurchargeExcludingTax: store.getters.getSurchargeHolidayAmount,
        surchargeTransactions: store.getters.getSurchargeTransactions,
      };
      orderModel = CreateOrderObject(
        store.getters.cartItems.filter((p) => !p.disable),
        store.getters.deliveryFee,
        priceItem,
        user,
        resturant,
        card,
        guid,
        orderInfo,
        guestUserId,
        store.getters.priceTriggerOutcomes,
        AppliedCouponList
      );
      orderModel.payment;
    }
    SetPaymentMethodType(orderModel, paymentMethod, stripeToken);
    if (twoStepPayment) {
      orderModel.PaymentGateway = 6;
    }
    const trackingOrderModel = {
      TrackingOrder: {
        Source: "Online Order",
        ...orderModel,
        AppliedCouponCodes: !AppliedCouponList
          ? null
          : AppliedCouponList.map((c) => {
              return c.coupon.CouponCode;
            }),
        RoomNumber: orderInfo.roomNumber,
        ...loyalty,
      },
    };
    if (orderInfo.tableNumber) {
      Object.defineProperty(trackingOrderModel.TrackingOrder, "Tables", {
        value: [
          { Name: orderInfo.tableNumber, SecurityCode: orderInfo.securityCode },
        ],
        enumerable: true,
      });
    }

    if (user.IsGuest) {
      const userObject = {
        FirstName: user.FirstName,
        LastName: user.LastName,
        Email: user.Email,
        CreateUserForGuest: user.CreateUserForGuest,
      };
      if(typeof user.DineInField != 'undefined') {
        userObject.DineInField = user.DineInField;
      }
      Object.defineProperty(trackingOrderModel, "GuestUser", {
        value: userObject,
        enumerable: true,
      });
    }
    if (card && Object.keys(card).length != 0) {
      if (isGift || (!card.exclude && store.getters.getTotalPrice > 0)) {
        let ExpiryYear = card.expYear;
        if (card.expYear.length != 4) {
          ExpiryYear = "20" + card.expYear.trim();
        }
        Object.defineProperty(trackingOrderModel, "Card", {
          value: {
            CardHolder: card.holder,
            CardNumber: ReplaceAll(card.number, " ", ""),
            ExpiryYear: ExpiryYear,
            ExpiryMonth: card.expMonth.trim(),
            Cvv: card.cvc,
            ForceUseSandboxPayment: AppConfig.ForceUseSandboxPayment == "true",
          },
          enumerable: true,
        });
      }
    }
    return trackingOrderModel;
  }

  Reorder(orderItem) {
    var order = Object.assign({}, orderItem);
    var guid = uuid();
    order.OnlineOrderStatus = 1;
    order.CreatedOn = new Date().toUTCString();
    order.InvoiceNumber = "";
    order.OnlineOrderStatusDescription = "";
    order.PaymentTransactions = [
      {
        Amount: order.PaymentTransactions[0].Amount,
      },
    ];
    order.ScheduledTime = new Date().toUTCString();
    delete order.IsTimeOut;
    for (var tempItem of order.OrderItems) {
      tempItem.CreatedOn = new Date().toUTCString();
      tempItem.UDID = uuid();
      for (var tempExtra of tempItem.OrderExtras) {
        tempExtra.UDID = uuid();
      }
    }
    order.UDID = guid;
    const trackingOrderModel = {
      TrackingOrder: {
        ...order,
      },
    };
    return instance.post("trackingorders/" + guid, trackingOrderModel);
  }

  PreparePaymentUrl(orderDetails) {
    var data = {
      PaymentType: orderDetails.PaymentType,
      StoreId: orderDetails.storeId,
      OrderId: orderDetails.orderId,
      UserId: orderDetails.userId,
      AppName: "Online Ordering",
      TotalAmount: orderDetails.totalAmount,
      ReturnUrl: document.location.href,
      IsMobile: orderDetails.isMobile,
    };

    return instance.post("supaypayment/supaypaymentstart", data);
  }
}

function SetPaymentMethodType(orderModel, paymentMethod, stripeToken) {
  switch (paymentMethod) {
    case 1: //Card
      orderModel.PaymentTransactions[0].PaymentMethodType = 99; //AbacusPayment
      break;
    case 2:
      orderModel.PaymentTransactions[0] = {Amount: 0}; //LoyaltyPointRedemption
      break;
    case 3:
      orderModel.PaymentTransactions[0].PaymentMethodType = 1; //Cash
      break;
    case 4:
      orderModel.PaymentTransactions[0].PaymentMethodType = 12; //AliPay
      break;
    case 5:
      orderModel.PaymentTransactions[0].PaymentMethodType = 13; //WeChat
      break;
    case 6:
      orderModel.PaymentTransactions[0].PaymentMethodType = 15; //Apple Pay
      orderModel.PaymentTransactions[0].RenfrenceNumber = stripeToken; //Apple Pay
      break;
    case 7:
      orderModel.PaymentTransactions[0].PaymentMethodType = 14; //Google Pay
      orderModel.PaymentTransactions[0].RenfrenceNumber = stripeToken; //Google Pay
      break;
    case 8:
      orderModel.PaymentTransactions[0].PaymentMethodType = null; //Eat In Pay Later
      break;
    case 9:
      orderModel.PaymentTransactions[0].PaymentMethodType = null; //Cash On Delivery
      orderModel.OrderType = 10;
      break;
  }
}
